<div
  *ngIf="visible"
  role="status"
  class="loader-overlay"
  [class.loader-overlay--active]="active"
>
  <div class="dashy-loader" aria-hidden="true">
    <span class="dashy-loader__ring"></span>
    <img
      src="assets/iconLogo.png"
      alt=""
      class="dashy-loader__logo"
    />
  </div>
  <span class="sr-only">{{ "APP_BUTTONS.LOADING" | translate }}</span>
</div>
